'use client';

import React, { createContext, useCallback, useContext, useState } from 'react';

export interface Headcount {
  adult: number;
  kid: number;
  pet: number;
}

interface HeadcountContextValue {
  headcount: Headcount;
  isInitialized: boolean;
  setHeadcount: (headcount: Headcount) => void;
}

const HeadcountContext = createContext<HeadcountContextValue | undefined>(undefined);

export function HeadcountProvider({ children }: { children: React.ReactNode }) {
  const [headcount, setHeadcountState] = useState<Headcount>({ adult: 1, kid: 0, pet: 0 });
  const [isInitialized, setIsInitialized] = useState(false);

  const setHeadcount = useCallback((next: Headcount) => {
    setHeadcountState(next);
    setIsInitialized(true);
  }, []);

  return (
    <HeadcountContext.Provider value={{ headcount, isInitialized, setHeadcount }}>
      {children}
    </HeadcountContext.Provider>
  );
}

export function useHeadcount() {
  const ctx = useContext(HeadcountContext);
  if (!ctx) {
    throw new Error('useHeadcount must be used within HeadcountProvider');
  }
  return ctx;
}
